export const MAKE_REQUEST = "NOTIFICATION_MAKE_REQUEST";
export const FAIL_REQUEST = "NOTIFICATION_FAIL_REQUEST";
export const SET_ORGANIZATION_DATA = "SET_ORGANIZATION_DATA";
